import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
import { LockIcon } from 'lucide-react';
const items = [{
  name: 'Tomo 1 — El Interruptor',
  value: '$5.990'
}, {
  name: 'Tomo 2 — Ingeniería de Guion',
  value: '$5.990'
}, {
  name: 'Tomo 3 — El Vacío Cuántico',
  value: '$5.990'
}, {
  name: 'Tomo 4 — El Cuerpo Magnético',
  value: '$5.990'
}, {
  name: 'Tomo 5 — El Guardián del Sueño',
  value: '$5.990'
}, {
  name: 'Bono 1 — El Radar de Sincronías',
  value: '$3.990'
}, {
  name: 'Bono 2 — Guiones de Auto-Hipnosis',
  value: '$3.990'
}, {
  name: 'Bono 3 — El Plan de 21 Días',
  value: '$3.990'
}];
export function ValueStackSection() {
  return <SectionWrapper bgColor="bg-brand-dark" data-id="element-253">
      <h2 className="font-heading text-2xl md:text-3xl text-brand-ivory text-center font-semibold" data-id="element-254">
        Lo que recibís hoy:
      </h2>

      <div className="mt-10 max-w-xl mx-auto" data-id="element-255">
        <div className="border border-brand-gold/15 rounded-xl overflow-hidden" data-id="element-256">
          {items.map((item, i) => <div key={i} className={`flex items-center justify-between px-5 py-3.5 ${i % 2 === 0 ? 'bg-white/[0.02]' : 'bg-transparent'}`} data-id="element-257">
              <span className="text-brand-ivory/80 font-body text-sm md:text-base" data-id="element-258">
                {item.name}
              </span>
              <span className="text-brand-gold font-body font-semibold text-sm md:text-base shrink-0 ml-4" data-id="element-259">
                {item.value}
              </span>
            </div>)}
          <div className="flex items-center justify-between px-5 py-4 bg-brand-gold/10 border-t border-brand-gold/20" data-id="element-260">
            <span className="text-brand-ivory font-body font-bold text-base md:text-lg" data-id="element-261">
              VALOR TOTAL
            </span>
            <span className="text-brand-gold font-heading font-bold text-lg md:text-xl" data-id="element-262">
              $41.920
            </span>
          </div>
        </div>
      </div>

      <div className="mt-14 text-center space-y-3" data-id="element-263">
        <p className="text-brand-muted font-heading text-xl md:text-2xl" data-id="element-264">
          Hoy no pagás $41.920
        </p>
        <p className="text-brand-muted font-heading text-xl md:text-2xl" data-id="element-265">
          Ni $29.990
        </p>
        <p className="text-brand-muted font-heading text-xl md:text-2xl" data-id="element-266">
          Ni $24.990
        </p>
      </div>

      <div className="mt-10 text-center" data-id="element-267">
        <p className="font-heading text-5xl md:text-7xl text-brand-gold font-bold" style={{
        textShadow: '0 0 40px rgba(212,175,55,0.3)'
      }} data-id="element-268">
          Solo $19.990
        </p>
        <p className="text-brand-ivory/80 font-body text-lg mt-4" data-id="element-269">
          8 documentos PDF — Acceso inmediato por MercadoPago
        </p>
      </div>

      {/* MercadoPago trust block */}
      <div className="mt-10 max-w-lg mx-auto" data-id="element-270">
        <div className="border border-brand-gold/15 rounded-lg bg-white/[0.02] px-5 py-5 text-center" data-id="element-271">
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-272">
            <LockIcon className="w-5 h-5 text-brand-gold" strokeWidth={1.5} data-id="element-273" />
            <span className="text-brand-gold font-body font-bold text-sm uppercase tracking-wider" data-id="element-274">
              Pago 100% seguro por MercadoPago
            </span>
          </div>
          <p className="text-brand-muted font-body text-sm leading-relaxed" data-id="element-275">
            Pagás con tu tarjeta de débito, crédito o dinero en cuenta de
            MercadoPago. Es el mismo sistema que usás todos los días.
          </p>
          <div className="mt-3 space-y-1.5 text-left max-w-sm mx-auto" data-id="element-276">
            <p className="text-brand-ivory/70 font-body text-xs" data-id="element-277">
              ✓ Tus datos van directo a MercadoPago
            </p>
            <p className="text-brand-ivory/70 font-body text-xs" data-id="element-278">
              ✓ Nunca pasan por nuestra página
            </p>
            <p className="text-brand-ivory/70 font-body text-xs" data-id="element-279">
              ✓ Recibís los archivos en tu email en menos de 5 minutos después
              del pago
            </p>
          </div>
        </div>
      </div>

      <div className="mt-10" data-id="element-280">
        <CTAButton text="→ SÍ, QUIERO EL SISTEMA COMPLETO POR $19.990" showTrust={false} data-id="element-281" />
        <p className="text-brand-muted-dark text-xs tracking-wide text-center mt-4 max-w-md mx-auto leading-relaxed" data-id="element-282">
          🔒 Pago seguro por MercadoPago ✓ Descarga instantánea ✓ Garantía 7
          días sin preguntas ✓ 390 páginas en 8 PDFs
        </p>
      </div>
    </SectionWrapper>;
}